module.exports = __webpack_public_path__ + "static/img/order_empty.cf7b718a.png";